import { render } from "./ComparePage.vue?vue&type=template&id=10cfeb5e&scoped=true"
import script from "./ComparePage.vue?vue&type=script&lang=js"
export * from "./ComparePage.vue?vue&type=script&lang=js"

import "./ComparePage.vue?vue&type=style&index=0&id=10cfeb5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10cfeb5e"]])

export default __exports__